import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/consultation/login/page.tsx");
